"use client";

import type { FC, Ref } from "react";
import { Ruler } from "@huub-web/ui";

export type RulerTemplateProps = Record<string, never> & {
  ref?: Ref<HTMLHRElement>;
};

/**
 * @deprecated 💀
 */
export const RulerTemplate: FC<RulerTemplateProps> = ({ ref, ...props }) => (
  <Ruler ref={ref} variant="currentColor" {...props} />
);
